import React from "react";
import PropTypes from "prop-types";

import LogoSm from "./svgs/logo-sm.svg?react";
import IconSm from "./svgs/icon-sm.svg?react";
import LogoMd from "./svgs/logo-md.svg?react";
import IconMd from "./svgs/icon-md.svg?react";
import LogoLg from "./svgs/logo-lg.svg?react";
import IconLg from "./svgs/icon-lg.svg?react";
import LogoXl from "./svgs/logo-xl.svg?react";
import IconXl from "./svgs/icon-xl.svg?react";

function EdgeLogo({ size = "md", icon = false, state = "dark" }) {
  const colorMap = {
    white: "#FFFFFF",
    black: "#000000",
    light: "#E5D9F9",
    dark: "#4A0F70",
    color: "#914DE8",
    sidebar: "#e5d9f9",
  };

  const svgStyle = {
    color: colorMap[state],
  };

  const getLogo = () => {
    switch (size) {
      case "sm":
        return icon ? IconSm : LogoSm;
      case "md":
        return icon ? IconMd : LogoMd;
      case "lg":
        return icon ? IconLg : LogoLg;
      case "xl":
        return icon ? IconXl : LogoXl;
      default:
        return LogoMd;
    }
  };

  const Logo = getLogo();

  return (
    <div className={`edge-logo edge-logo-${size} edge-logo-${state}`}>
      <Logo style={svgStyle} />
    </div>
  );
}

EdgeLogo.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  icon: PropTypes.bool,
  state: PropTypes.oneOf(["color", "light", "white", "dark", "black"]),
};

export default EdgeLogo;
